import { render, staticRenderFns } from "./NotificationNotipayModalEditComponent.vue?vue&type=template&id=74001256&scoped=true"
import script from "./NotificationNotipayModalEditComponent.vue?vue&type=script&lang=js"
export * from "./NotificationNotipayModalEditComponent.vue?vue&type=script&lang=js"
import style0 from "./NotificationNotipayModalEditComponent.vue?vue&type=style&index=0&id=74001256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74001256",
  null
  
)

export default component.exports